export const maskCpfOnChange = e => {
    const keyPressed = e.key
    const value = e.target.value.replace(/\D/g, '')
    if ( keyPressed !== undefined && /\D/.test(keyPressed) ) {
        e.preventDefault()
    } else {
        e.target.value = maskCpf(value)
    }
}

export const maskCnpjOnChange = e => {
    const keyPressed = e.key
    const value = e.target.value.replace(/\D/g, '')
    if ( keyPressed !== undefined && /\D/.test(keyPressed) ) {
        e.preventDefault()
    } else {
        e.target.value = maskCnpj(value)
    }
}

export const maskCepOnChange = e => {
    const keyPressed = e.key
    const value = e.target.value.replace(/\D/g, '')
    if ( keyPressed !== undefined && /\D/.test(keyPressed) ) {
        e.preventDefault()
    } else {
        e.target.value = maskCep(value)
    }
}

export const maskTelefoneOnChange = e => {
    const keyPressed = e.key
    const value = e.target.value.replace(/\D/g, '')
    if (keyPressed !== undefined && /\D/.test(keyPressed)) {
        e.preventDefault()
    } else {
        e.target.value = maskTelefone(value)
    }
}

export const alphaOnlyOnChange = e => {
    e.target.value = e.target.value.replace(/[^a-z0-9]/gi, '').substr(0, 30)
}

export const maskRgOnChange = e => {
    const value = e.target.value.replace(/\D(?=[a-zA-Z0-9])/g, '')
    e.target.value = maskRg(value)
}

export const maskAgenciaOnChange = e => {
    e.target.value = maskAgencia(e.target.value)
}

export const maskContaOnChange = e => {
    e.target.value = maskConta(e.target.value)
}

export const maskNomeOnChange = e => {
    e.target.value = maskNome(e.target.value)
}

export const maskCpf = value => (
    value.replace(/(\d{0,11})[\s\S]*/, '$1')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
)

export const maskCnpj = value => (
    value.replace(/(\d{0,14})[\s\S]*/, '$1')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
)

export const maskTelefone = value => {
    const length = value.length
    value = value.replace(/(\d{0,11})[\s\S]*/, '$1').replace(/(\d{2})(\d*)/, '($1) $2')
    if (length < 11) {
        value = value.replace(/(\(\d{2}\)\s)(\d{4})(\d*)/, '$1$2-$3')
    } else {
        value = value.replace(/(\(\d{2}\)\s)(\d{5})(\d*)/, '$1$2-$3')
    }
    return value
}

export const maskRg = value => (
    value.replace(/(\d{0,8}[0-9x])[\s\S]*/i, '$1')
        .replace(/(\d{2})(\d{1,3})/, '$1.$2')
        .replace(/(\d{3})(\d{1,3})/, '$1.$2')
        .replace(/(\d{3})([0-9x])$/i, '$1-$2')
        .toUpperCase()
)

export const maskAgencia = value => (
    value.replace(/\D/g, '')
)

export const maskConta = value => (
    value.replace(/[^0-9-]/g, '')
        .replace(/(\d+)(-?\d?)[\s\S]*/, '$1$2')
)

export const maskNome = value => (
    value.replace(/^\w/, c => c.toUpperCase())
        .replace(/\s\w/g, c => c.toUpperCase())
)

export const maskValorOnChange = value => (
   value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
)

export const maskCep = value => (
    value = value.replace(/(\d{0,8})[\s\S]*/, '$1')
        .replace(/(\d{5})(\d)/, '$1-$2')
)